import { request } from '../../utils/request';

export const getConversations = (authToken: string) =>
  request({
    method: 'GET',
    url: '/messaging/conversations',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
